import {useEffect} from 'react';
import {SimpleAction} from '../types/Action';

type Props = {
  intervalSeconds?: number;
  action?: SimpleAction;
};

export function ReloadWidget(props: Props): JSX.Element | null {
  const seconds = props.intervalSeconds ?? 5 * 60; /* default is 5 minutes */
  const interval = seconds * 1000;
  const action = props.action;

  useRetryUntilSuccess(action, interval);

  return null;
}

function useRetryUntilSuccess(
  fn: (() => void | Promise<void>) | undefined,
  interval: number,
) {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    let cancelled = false;

    const attempt = async () => {
      try {
        if (fn) {
          await fn();
        }
      } catch {
        if (cancelled) {
          return;
        }

        timer = setTimeout(attempt, interval);
      }
    };

    timer = setTimeout(attempt, interval);

    return () => {
      cancelled = true;

      if (timer !== null) {
        clearTimeout(timer);
      }
    };
  }, [fn, interval]);
}
